module.exports = __webpack_public_path__ + "img/ssyx_43.57f525e6.jpg";